module.exports = __webpack_public_path__ + "static/media/camera-border.c1f08683.svg";